module.exports = __webpack_public_path__ + "images/d3ef7aeb3d648a19be07d68648fe9f51.svg";